<template>
  <Card>
    <CardHeading heading="About" :showCapacity="false" :showButton="false" />
    <Input
      id="companyName"
      :value="aboutLabel"
      name="name"
      label="Company name"
      :disabled="true"
      class="mb-4"
    />
    <Input
      id="profileWebsite"
      :value="profileData.renderWebsite"
      name="profileWebsite"
      label="Company website"
      placeholder="https://example.com"
      :required="true"
      :field-validator="validateWebsite"
      @input-change="handleWebsiteChange($event, 'updateWebsite')"
      class="mb-4"
    />
    <Input
      v-if="integrationPartner || vendorOPP"
      id="companyHeadline"
      :value="profileData.headline"
      @input-change="handleRichTextChange"
      height="250px"
      type="textarea"
      :limit="200"
      name="setHeadline"
      label="Headline"
      placeholder="Short description to appear at the top of your profile"
    />
    <Input
      id="companyRenderAbout"
      :value="profileData.renderAboutUs"
      :limit="1000"
      @input-change="handleRichTextChange"
      name="setAboutUs"
      type="texteditor"
      :label="'About ' + aboutLabel"
      :required="true"
      class="mb-4"
      placeholder="Briefly tell us about your partner’s company"
    />
    <Input
      id="companySharedAbout"
      :value="profileData.sharedAboutUs"
      :limit="1000"
      @input-change="handleRichTextChange"
      name="setSharedAboutUs"
      type="texteditor"
      class="mb-4"
      :label="sharedAboutLabel.first + ' & ' + companyName"
      :placeholder="sharedAboutPlaceholder"
    />

    <FileUploader
      id="companyLogo"
      :existingImg="profileData.renderImage"
      @update-image="handleFileChange"
      field="renderImage"
      buttonText="Replace image"
      buttonType="ghost"
      :forceUpload="true"
      :label="aboutLabel + ' Logo'"
      accept=".png, .jpg, .jpeg, .gif"
      zoneText="Click or drag here to upload an image"
      uploadDescription="<p class='fs-sm' style='color: #727a88;'><span style='font-weight: 600;'>File type:</span> JPG, PNG | <span style='font-weight: 600'>Min-width:</span> 400px | <span style='font-weight: 600'>Background:</span> Transparent</p>"
    />
  </Card>
</template>

<script>
import Card from '@/components/DesignSystem/Card';
import CardHeading from '@/components/DesignSystem/CardHeading';
import Input from '@/components/DesignSystem/Input';
import FileUploader from '@/components/DesignSystem/FileUploader';
import { validateWebsite } from '@/components/DesignSystem/validators';

export default {
  name: 'AboutContentSection',
  props: {
    namespace: String,
    integrationPartner: Boolean,
    OPP: Boolean,
    managePartners: Boolean,
    vendorOPP: Boolean,
  },
  components: {
    Input,
    CardHeading,
    Card,
    FileUploader,
  },
  computed: {
    profileData() {
      return this.$store.getters[`${this.namespace}/profileData`];
    },
    companyName() {
      if (this.profileData) {
        return (
          this.profileData.directoryAgencyName ||
          this.profileData.directoryVendorName
        );
      }
      return null;
    },
    sharedAboutPlaceholder() {
      if (this.aboutLabel && this.companyName) {
        this.$forceUpdate();
        return `Briefly explain how ${this.aboutLabel} and ${this.companyName} work together`;
      }
      return '';
    },
    aboutLabel() {
      if (this.integrationPartner) {
        return this.profileData.name;
      } else if (this.OPP) {
        return this.$store.getters['details'].vendorData.name;
      } else if (this.managePartners) {
        return this.profileData.companyName;
      }
      return '';
    },
    sharedAboutLabel() {
      if (this.integrationPartner) {
        return {
          first: this.profileData.name,
          second:
            sessionStorage.getItem('vendorName') ||
            this.$store.getters['details'].vendorData.name,
        };
      }
      if (this.OPP) {
        return {
          first: this.$store.getters['details'].vendorData.name,
          second: this.$store.getters['ourPublicProfiles/activeProfile'],
        };
      }

      if (this.managePartners) {
        return {
          first: this.profileData.companyName,
        };
      }
      return {};
    },
  },
  methods: {
    validateWebsite,

    handleRichTextChange(payload) {
      let value = payload.value;

      // regex is to remove html tags; sometimes there will
      // be no text in the editor but there will still be
      // extra div and br tags
      const hasText = value.replace(/(<([^>]+)>)/gi, '');

      if (!hasText) {
        value = '';
      }

      this.$store.commit(`${this.namespace}/${payload.key}`, value);
      this.$store.dispatch(`${this.namespace}/addDirtyTab`, {
        endpoint: '',
        storeKey: 'profile',
      });
    },
    handleFileChange(files) {
      this.$store.dispatch(`${this.namespace}/updateImage`, files);
    },

    handleWebsiteChange(payload, action) {
      this.$store.dispatch(`${this.namespace}/${action}`, payload.value);
      this.$store.dispatch(`${this.namespace}/addDirtyTab`, {
        endpoint: '',
        storeKey: 'profile',
      });
    },
  },
};
</script>

<style lang="scss">
.inputLabel {
  text-transform: initial;
  font-weight: 600;
}

.select select,
.select::after {
  z-index: 0;
}
</style>
